import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { JOURNAL } from "@/constants/testIds";
import RevealLines from "@/components/site/RevealLines";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.19, 1, 0.22, 1] },
  },
};

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data));
  }, []);

  return (
    <main className="pt-32 md:pt-40 pb-32 px-6 md:px-10">
      <div className="max-w-[1600px] mx-auto">
        <div className="text-[10px] tracking-[0.35em] uppercase text-[color:var(--vv-bone-dim)] mb-6">
          — Dispatches from the Desk
        </div>
        <h1 className="font-serif-vv text-6xl md:text-[10vw] leading-[0.9] tracking-tighter">
          <RevealLines lines={["Journal."]} />
        </h1>

        <div className="mt-24 divide-y vv-line border-y vv-line">
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: (i % 3) * 0.08 }}
              data-testid={JOURNAL.card(p.slug)}
              className="group"
            >
              <Link to={`/journal/${p.slug}`} className="block py-12 md:py-16">
                <div className="grid grid-cols-12 gap-6 items-center">
                  <div className="col-span-12 md:col-span-2 text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)]">
                    {p.kicker}
                  </div>
                  <div className="col-span-12 md:col-span-7">
                    <h2 className="font-serif-vv text-4xl md:text-6xl leading-tight tracking-tight group-hover:italic group-hover:text-[color:var(--vv-ember)] transition-all duration-500">
                      {p.title}
                    </h2>
                    <p className="mt-4 text-[color:var(--vv-bone-dim)] max-w-2xl">
                      {p.excerpt}
                    </p>
                  </div>
                  <div className="col-span-12 md:col-span-3 text-xs uppercase tracking-[0.3em] text-[color:var(--vv-ember)] md:text-right">
                    Read →
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </main>
  );
}
